<div class="step__title">
    <ng-content></ng-content>
</div>